import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Typography from '@material-ui/core/Typography';

import Button from 'components/common/Button';
import Link from 'components/common/Link';
import IconLogo from 'components/icons/IconLogo';
import IconButton from 'components/common/IconButton';
import IconCross from 'components/icons/IconCross';

import pxToRem from 'styles/pxToRem';

import DefaultHeaderNavigation from './DefaultHeaderNavigation';

const styles = theme => ({
  root: {
    height: '64px',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    justifyContent: 'space-between',
    alignItems: 'center',
    boxShadow: 'none',
    zIndex: 1200,
    background: theme.palette.common.white,
    borderBottom: `1px solid ${theme.palette.grey[300]}`,
    [theme.breakpoints.down('sm')]: {
      left: 0,
      right: 'auto',
      maxWidth: '100vw',
    },
  },
  rootVariantSettings: {
    [theme.breakpoints.down('sm')]: {
      left: 0,
      right: 'auto',
      maxWidth: '100vw',
    },
    '& $heading': {
      display: 'block',
      [theme.breakpoints.down('sm')]: {
        display: 'none',
      },
    },
    '& $defaultHeaderNavigation': {
      [theme.breakpoints.down('sm')]: {
        display: 'none',
      },
    },
  },
  rootVariantPrint: {
    [theme.breakpoints.down('sm')]: {
      left: 0,
      right: 'auto',
      maxWidth: '100vw',
    },
    '& $heading': {
      display: 'block',
      [theme.breakpoints.down('sm')]: {
        display: 'none',
      },
    },
    '& $defaultHeaderNavigation': {
      [theme.breakpoints.down('sm')]: {
        display: 'none',
      },
    },
  },
  heading: {
    marginLeft: 25,
    [theme.breakpoints.down('sm')]: {
      marginLeft: 48,
    },
  },
  defaultHeaderNavigation: {
    marginRight: 25,
    [theme.breakpoints.down('sm')]: {
      marginRight: 8,
    },
  },
  button: {
    height: '20px',
    width: '106px',
    verticalAlign: 'top',
    padding: '2px 5px 0 5px',
    transition: theme.transitions.create(['opacity'], {
      duration: theme.transitions.duration.short,
    }),
    '&:hover, &:focus': {
      opacity: '0.6',
      background: 'transparent',
    },
  },
  iconLogo: {
    height: 30,
    width: 89,
  },
  linkVersion: {
    fontSize: pxToRem(10),
    color: theme.palette.text.primary,
    top: 3,
    right: 32,
    position: 'absolute',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  settingsHeading: {
    marginLeft: 55,
    display: 'none',
    [theme.breakpoints.down('sm')]: {
      display: 'block',
    },
  },
  buttonClose: {
    display: 'none',
    [theme.breakpoints.down('sm')]: {
      display: 'block',
    },
  },
  iconCross: {
    width: 14,
    height: 14,
  },
});

const DefaultHeader = ({ variant, classes, record, titleText }) => {
  const lastRecordBeforeSettings = record.slice().reverse()
    .find(item => item.pathname.indexOf('settings') === -1
      && item.pathname.indexOf('profile') === -1);
  return (
    <AppBar
      position="fixed"
      color="secondary"
      className={classNames(classes.root, {
        [classes.rootVariantSettings]: variant === 'settings',
        [classes.rootVariantPrint]: variant === 'print',
      })}
    >
      <Typography
        variant="display1"
        className={classes.heading}
      >
        <Button
          disableRipple
          className={classes.button}
          href="/"
        >
          <IconLogo className={classes.iconLogo} color="dark" />
        </Button>
      </Typography>
      {(variant === 'settings' || variant === 'print') &&
        <Fragment>
          <Typography
            variant="title"
            className={classes.settingsHeading}
          >
            {variant === 'settings' ? 'Settings' : titleText}
          </Typography>
          <IconButton
            className={classes.buttonClose}
            href={lastRecordBeforeSettings ? lastRecordBeforeSettings.pathname : '/'}
            tooltipContent="Close Dialog"
          >
            <IconCross className={classes.iconCross} />
          </IconButton>
        </Fragment>
      }
      <DefaultHeaderNavigation className={classes.defaultHeaderNavigation} variant={variant} />
      <Link
        size="md"
        href="/versions"
        target="_blank"
        className={classes.linkVersion}
      >
        Version 3.13.3
      </Link>
    </AppBar>
  );
};

DefaultHeader.propTypes = {
  variant: PropTypes.oneOf(['default', 'settings']),
  titleText: PropTypes.string,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    button: PropTypes.string.isRequired,
    iconLogo: PropTypes.string.isRequired,
    defaultHeaderNavigation: PropTypes.string.isRequired,
  }).isRequired,
};

DefaultHeader.defaultProps = {
  variant: 'default',
  titleText: '',
};

export default withStyles(styles)(DefaultHeader);



// WEBPACK FOOTER //
// ./src/components/common/Layout/DefaultHeader/DefaultHeader.js